import React, { Component } from 'react';
import { Map, YMaps, ZoomControl } from 'react-yandex-maps';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _isEmpty from 'lodash/isEmpty';
import { MAP } from 'react-google-maps/lib/constants';

// Components
import Preloader from '../../../Preloader';
import { GMaps } from '../../../GoogleMap';

// Assets
import locationIcon from '../../assets/location.svg';

// Config
import config from '../../../../config';

// Styles
import styles from './Map.styl';
import _filter from 'lodash/filter';
import { connect } from 'react-redux';
import { SimpleMapPolygons } from '../../../ContactsMap/GMap/SimpleMapLolygons';

const cx = classNames.bind(styles);

class AddressMap extends Component {
  constructor(props) {
    super(props);
    this.address = props.selectedAddress;
    this.lastProcessedAddress = null;
  }

  state = {
    isLoaded: false,
    currentCenter: [],
  };

  componentDidUpdate(prevProps) {
    const { isLoaded } = this.state;
    const { selectedAddress } = this.props;

    if (
      selectedAddress !== prevProps.selectedAddress &&
      selectedAddress !== this.lastProcessedAddress &&
      isLoaded
    ) {
      if (config.legal === 'pl') {
        this.setGoogleMarker(true, selectedAddress);
      } else {
        this.geocodePlacemark(selectedAddress);
      }
    }
  }

  componentWillUnmount() {
    if (this.userMarker) {
      this.userMarker.setMap(null);
    }

    if (this.mapContext) {
      google.maps.event.clearListeners(this.mapContext, 'click');
    }
  }

  // GOOGLE

  getMapRef = ref => {
    if (ref) {
      this.mapContext = ref.context[MAP];
      this.setState({ isLoaded: true });

      if (this.mapContext) {
        this.geocoder = new google.maps.Geocoder();

        this.mapContext.addListener('click', e => {
          this.setGoogleMarker(false, new google.maps.LatLng(e.latLng.lat(), e.latLng.lng()));
        });

        const { selectedAddress } = this.props;

        // СТАВИМ ПИН ПРИ ИНИЦИАЛИЗАЦИИ ЕСЛИ УЖЕ ЕСТЬ АДРЕС
        if (selectedAddress && selectedAddress !== this.lastProcessedAddress) {
          this.setGoogleMarker(true, selectedAddress);
        }
      }
    }
  };

  setGoogleMarker = (isAddress, data) => {
    const { mapAddressOnChange } = this.props;

    if (data && this.geocoder) {
      const request = isAddress ? { address: data } : { location: data };

      if (this.userMarker) {
        this.userMarker.setMap(null);
      }

      this.geocoder.geocode(request, (results, status) => {
        if (status === 'OK' && results[0]) {
          const location = results[0].geometry.location;

          this.userMarker = new google.maps.Marker({
            map: this.mapContext,
            icon: locationIcon,
            position: location,
          });

          const newAddress = results[0].formatted_address;

          if (newAddress) {
            this.lastProcessedAddress = newAddress;
            this.address = newAddress;
            mapAddressOnChange(newAddress);
            this.mapContext.setCenter(location);
          }
        } else {
          console.error(`Geocode failed: ${status}`);
        }
      });
    }
  };

  // YANDEX

  instanceRef = ref => {
    this.mapRef = ref;
  };

  setMapCenter = (coordinates, zoom = false) => {
    this.mapRef.setCenter(coordinates);
    this.setState({ currentCenter: coordinates });

    if (zoom) {
      this.mapRef.setZoom(zoom);
    }
  };

  setPlacemark = coords => {
    this.searchPlacemark.geometry.setCoordinates(coords);
    this.searchPlacemark.options.set('visible', true);
  };

  setAddressFromGeoObject = geoObject => {
    const { mapAddressOnChange } = this.props;

    this.address = geoObject.getAddressLine();

    if (this.address) {
      this.lastProcessedAddress = this.address;
      mapAddressOnChange(this.address);
    }
  };

  handleApiAvaliable = selectedYmaps => {
    const { selectedAddress } = this.props;

    this.ymaps = selectedYmaps;

    this.ymaps.load(() => {
      this.mapRef.cursors.push('arrow');
      this.setState({ isLoaded: true });

      this.searchPlacemark = new this.ymaps.Placemark(
        [0, 0],
        {},
        {
          iconLayout: 'default#image',
          iconImageHref: locationIcon,
          iconImageSize: [26, 26],
          iconImageOffset: [-13, -26],
          cursor: 'default',
          visible: false,
        },
      );

      this.mapRef.geoObjects.add(this.searchPlacemark);

      if (selectedAddress) {
        this.geocodePlacemark(selectedAddress);
      } else {
        navigator.geolocation.getCurrentPosition(position => {
          const coords = [position.coords.latitude, position.coords.longitude];
          this.setPlacemark(coords);

          this.ymaps
            .geocode(coords)
            .then(res => {
              this.setAddressFromGeoObject(res.geoObjects.get(0));
              this.setMapCenter(coords, 15);
            })
            .catch(e => {
              console.error('Yandex Maps Api', e);
              this.searchPlacemark.options.set('visible', false);
            });
        });
      }

      this.mapRef.events.add('click', e => {
        const coords = e.get('coords');
        this.setPlacemark(coords);

        this.ymaps
          .geocode(coords)
          .then(res => {
            this.setAddressFromGeoObject(res.geoObjects.get(0));
            this.setMapCenter(coords);
          })
          .catch(error => {
            console.error('Yandex Maps Api', error);
            this.searchPlacemark.options.set('visible', false);
          });
      });
    });
  };

  checkWorkingAtNight = item => !item.areas_details.some(el => el.activeCategory);

  geocodePlacemark = address => {
    if (this.searchPlacemark) {
      this.searchPlacemark.options.set('visible', false);
    }

    let addressString = typeof address === 'object' && address.value ? address.value : address;

    if (this.ymaps && this.mapRef) {
      this.ymaps
        .geocode(addressString)
        .then(res => {
          const coords = res.geoObjects.get(0).geometry.getCoordinates();
          if (coords) {
            this.setPlacemark(coords);
            this.setMapCenter(coords, 15);
            this.address = addressString;
            this.lastProcessedAddress = addressString;
          }
        })
        .catch(e => {
          console.error('Yandex Maps Api', e);
        });
    }
  };

  render() {
    const { className, center, mapLocale, width, height, restaurant } = this.props;
    const { currentCenter, isLoaded } = this.state;
    return (
      <div className={cx('Map', className)}>
        {!isLoaded && <Preloader className={cx('Map__preloader')} />}
        {config.legal === 'pl' ? (
          <GMaps
            loadingElement={<div />}
            containerElement={<div style={{ width: '100%', height: '100%' }} />}
            mapElement={<div style={{ width: '100%', height: '100%', zIndex: '2' }} />}
            defaultZoom={10}
            defaultCenter={center}
            options={{
              streetViewControl: false,
              mapTypeControl: false,
              draggableCursor: 'crosshair',
            }}
            getMapRef={this.getMapRef}
          >
            {restaurant?.isLoaded &&
              restaurant?.list?.map(item => {
                if (this.checkWorkingAtNight(item)) {
                  return _filter(item.areas_details, {
                    category: 'day',
                  }).map(area => <SimpleMapPolygons key={area.polygon_id} item={area} />);
                } else {
                  return false;
                }
              })}
          </GMaps>
        ) : (
          <YMaps query={{ lang: mapLocale, apikey: config.yandexApiKey }} enterprise>
            <Map
              onLoad={this.handleApiAvaliable}
              width={width}
              height={height}
              instanceRef={this.instanceRef}
              state={{
                center: _isEmpty(currentCenter) ? center : currentCenter,
                zoom: 10,
              }}
            >
              <ZoomControl />
            </Map>
          </YMaps>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userCity: state.city.userCity,
  restaurant: state.restaurant,
});
export default connect(mapStateToProps)(AddressMap);

AddressMap.defaultProps = {
  className: '',
  width: '100%',
  height: '100%',
};

AddressMap.propTypes = {
  className: PropTypes.string,
  mapAddressOnChange: PropTypes.func.isRequired,
  selectedAddress: PropTypes.string.isRequired,
  mapLocale: PropTypes.string.isRequired,
  center: PropTypes.array.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  restaurant: PropTypes.object.isRequired,
};
